export const adminPermission = {
  clientFilter: true,
};
